<template lang='pug'>
include /mixins
+b.leaflet-map-wrapper
  row.max-height(space='none')
    cell(cols='12 3-xl')
      div.max-height#placeSideBar
        +b.presentation-elevators
          row(
            justify='between'
            space='none'
          )
            cell
              +b.logo
                +e.IMG.img(:src='logo')
                +b.wrap-text
                  +e.H1.title.ds-caption.--color-blue-dark.--uppercase {{ _('Мапа елеваторів України')}}
            cell(align='center')
              +b.languages
                +e.A.link.ds-caption.--size-12.--color-gray-light.--decoration-none(
                  :class="{current: currentLanguage === 'ru' }"
                  href='/ru'
                ) ru
                +e.A.link.ds-caption.--size-12.--color-gray-light.--decoration-none(
                  href='/'
                  :class="{current: currentLanguage === 'uk' }"
                ) ua
        +b.wrap-elevator.--mobail
          +b.BUTTON.button-accordion(@click='toggleElevators = !toggleElevators')
            +e.SPAN.text {{ _('Список элеваторов')}}
          +b.place-elevators
            vue-accordion(:expanded='toggleElevators')
              +b.elevator(
                v-for='elevator in placesArray',
                :id="elevator.label"
                @click="toggleInfoWindow(elevator, elevator.label)"
              )
                +e.SPAN.ic.icon-marker
                +e.SPAN.title(
                ) {{ elevator.company }}
        +b.wrap-elevator.--desktop
          +b.place-elevators
            +b.elevator(
              v-for='elevator in placesArray',
              :id="elevator.label"
                @click="toggleInfoWindow(elevator, elevator.label), toggleElevators = false"
            )
              +e.SPAN.ic.icon-marker
              +e.SPAN.title(
              ) {{ elevator.company }}
    cell(cols="12 9-xl")
      map-filters(
        ref="filters",
        base-url="/profile/map/",
        :list-resource="announcementMapListResource",
        :filters-resource="announcementOptionsResource",
        @result="setResults"
      )
      gmap-map#map(
        :class='{ blockButtons: infoWinOpen }'
        :center="center",
        :zoom="zoom",
        :options="mapStyle",
        key="map"
      )
        gmap-cluster(
          :styles="clusterOptions",
          :minimumClusterSize="cluster",
          :zoomOnClick="true",
          key="clusters"
        )
          gmap-marker.marker(
            v-for="markers, i in placesArray",
            :position="{ lat: parseFloat(markers.point_y), lng: parseFloat(markers.point_x) }",
            :key="`marker_${i}`",
            :title='markers.label'
            :clickable="true",
            :icon="infoWindowActive === markers.label ? markerCurrent : markerImage",
            @click="toggleInfoWindow(markers, markers.label)"
          )
        gmap-info-window#infoWindow(
          key="infowindow",
          :options="infoOptions",
          :opened="infoWinOpen",
          @closeclick="breakSettings()",
          :position="infoWindowPos"
        )
          +b.ds-caption.--size-25.--color-blue-dark.--weight-bold
            +e.SPAN.ic.icon-map
            +e.SPAN.text {{ infoContent.company }}
          +b.contacts-modal
            +e.A.link.ds-caption.--color-blue-light.--size-14.--hover.--pointer.--decoration-none(
              :href='infoContent.route'
              target='_blank'
            ) {{ _('Показать маршрут')}}
          +b.contacts-modal(v-if='infoContent.company')
            row
              cell(v-if='Object.keys(infoContent.json_sites).length !== 0')
                +b.contacts-link.ds-caption.--color-blue-light.--size-14.--hover.--pointer
                  +e.SPAN.ic.icon-link
                  +e.wpapper-links
                    +e.A.link.ds-caption.--decoration-none.--hover(
                      :href='item.title'
                      v-for='item in infoContent.json_sites'
                    ) {{item.title}}
              cell(v-if='Object.keys(infoContent.json_emails).length !== 0')
                +b.contacts-link.ds-caption.--hover.--pointer.--size-14.--color-blue-light
                  +e.SPAN.title.ds-caption.--decoration-none.--color-blue-dark {{ _('E-mail')}}
                  +e.wpapper-links
                    +e.A.link.ds-caption.--decoration-none.--hover(
                      :href="'mailto:' + item.title"
                      v-for='item in infoContent.json_emails'
                    ) {{ item.title }}

          +b.main-elevator-info
            row(justify='center between-xl')
              cell(cols='12 auto-md')
                +b.wrapper-for-info
                  +e.title.ds-caption.--size-12.--color-gray-light.--weight-medium {{ _('Хранение тонн')}}
                  +e.place-for-data
                    +e.SPAN.text.ds-caption.--color-blue-medium.--weight-bold.--size-25 {{ infoContent.storage }}
              cell(
                v-if='infoContent.shipments'
                cols='12 auto-md'
              )
                +b.wrapper-for-info.helper
                  +e.title.ds-caption.--size-12.--color-gray-light.--weight-medium(
                    :class='{"another-padding": infoContent.shipments.length !== 2}'
                  ) {{ _('Отгрузка')}}
                  row(justify='center-md')
                    cell(v-if='infoContent.shipments[0]')
                      +e.place-for-data
                        +e.IMG.img(
                          v-if='infoContent.shipments[0].icon'
                          :src='infoContent.shipments[0].icon'
                        )
                        +e.SPAN.ic.icon-car(v-else)
                    cell(v-if='infoContent.shipments[1]')
                      +e.place-for-data
                        +e.IMG.img(
                          v-if='infoContent.shipments[1].icon'
                          :src='infoContent.shipments[1].icon'
                        )
                        +e.SPAN.ic.icon-rail(v-else)
              cell(
                v-if='infoContent.register_code'
                cols='12 auto-md'
              )
                +b.wrapper-for-info
                  +e.title.ds-caption.--size-12.--color-gray-light.--weight-medium {{ _('ЕДРПОУ')}}
                  +e.place-for-data
                    +e.SPAN.text.ds-caption.--size-14.--color-gray-light-another {{ infoContent.register_code }}
          +b.detail-elevator-info
            row
              cell(
                cols='12'
                v-if='infoContent.owner'
              )
                +b.text-detail-elevator
                  row(justify='between')
                    cell
                      +b.information-elevator-title
                        +e.SPAN.ic.icon-briefcase
                        +e.SPAN.text.ds-caption.--color-gray-light.--size-12.--weight-bold {{ _('Компания')}}
                    cell(cols='4 6-md')
                      +b.information-elevator-title
                        +e.P.content.ds-caption.--color-gray-light-another.--size-12 {{ infoContent.owner }}
              cell(
                cols='12'
                v-if='infoContent.location_description'
              )
                +b.text-detail-elevator
                  row(justify='between')
                    cell
                      +b.information-elevator-title
                        +e.SPAN.ic.icon-locate-fixed
                        +e.SPAN.text.ds-caption.--color-gray-light.--size-12.--weight-bold {{ _('Месторасположение')}}
                    cell(cols='4 6-md')
                      +b.information-elevator-title
                        +e.P.content.ds-caption.--color-gray-light-another.--size-12 {{ infoContent.location_description }}
              cell(
                cols='12'
                v-if='infoContent.address'
              )
                +b.text-detail-elevator
                  row(justify='between')
                    cell
                      +b.information-elevator-title
                        +e.SPAN.ic.icon-marker
                        +e.SPAN.text.ds-caption.--color-gray-light.--size-12.--weight-bold {{ _('Адрес')}}
                    cell(cols='4 6-md')
                      +b.information-elevator-title
                        +e.P.content.ds-caption.--color-gray-light-another.--size-12 {{ infoContent.address }}
              cell(
                cols='12'
                v-if='infoContent.contacts'
              )
                +b.text-detail-elevator
                  row(justify='between')
                    cell
                      +b.information-elevator-title
                        +e.SPAN.ic.icon-phone-incoming
                        +e.SPAN.text.ds-caption.--color-gray-light.--size-12.--weight-bold {{ _('Контакты')}}
                    cell(cols='4 6-md')
                      +b.information-elevator-title
                        +e.P.content.ds-caption.--color-gray-light-another.--size-12 {{ infoContent.contacts }}

</template>

<script>
import {
  announcementMapListResource,
  announcementOptionsResource,
  elevatorData,
} from '@api/elevator.service';

import GmapCluster from 'vue2-google-maps/dist/components/cluster';

const clusterImg = '/static/svg/uEA13-cluster.svg';

export default {
  components: {
    GmapCluster,
  },
  data() {
    return {
      infoWindowActive: '',
      toggleElevators: false,
      mapStyle: {
        scrollwheel: true,
        draggable: true,
        // other properties...
        styles: [
          {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [
              {
                color: '#e9e9e9',
              },
              {
                lightness: 17,
              },
            ],
          },
          {
            featureType: 'landscape',
            elementType: 'geometry',
            stylers: [
              {
                color: '#f5f5f5',
              },
              {
                lightness: 20,
              },
            ],
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#ffffff',
              },
              {
                lightness: 17,
              },
            ],
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#ffffff',
              },
              {
                lightness: 29,
              },
              {
                weight: 0.2,
              },
            ],
          },
          {
            featureType: 'road.arterial',
            elementType: 'geometry',
            stylers: [
              {
                color: '#ffffff',
              },
              {
                lightness: 18,
              },
            ],
          },
          {
            featureType: 'road.local',
            elementType: 'geometry',
            stylers: [
              {
                color: '#ffffff',
              },
              {
                lightness: 16,
              },
            ],
          },
          {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [
              {
                color: '#f5f5f5',
              },
              {
                lightness: 21,
              },
            ],
          },
          {
            featureType: 'poi.park',
            elementType: 'geometry',
            stylers: [
              {
                color: '#dedede',
              },
              {
                lightness: 21,
              },
            ],
          },
          {
            elementType: 'labels.text.stroke',
            stylers: [
              {
                visibility: 'on',
              },
              {
                color: '#ffffff',
              },
              {
                lightness: 16,
              },
            ],
          },
          {
            elementType: 'labels.text.fill',
            stylers: [
              {
                saturation: 36,
              },
              {
                color: '#333333',
              },
              {
                lightness: 40,
              },
            ],
          },
          {
            elementType: 'labels.icon',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'transit',
            elementType: 'geometry',
            stylers: [
              {
                color: '#f2f2f2',
              },
              {
                lightness: 19,
              },
            ],
          },
          {
            featureType: 'administrative',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#fefefe',
              },
              {
                lightness: 20,
              },
            ],
          },
          {
            featureType: 'administrative',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#fefefe',
              },
              {
                lightness: 17,
              },
              {
                weight: 1.2,
              },
            ],
          },
        ],
      },
      logo: '',
      center: { lat: 48.6865, lng: 31.4588 },
      zoom: 5,
      cluster: 2,
      placesArray: [],
      currentLanguage: window.language,
      currentMarker: -2,
      infoWinOpen: false,
      infoWindowPos: { lat: 48.6865, lng: 31.4588 },
      infoContent: {},
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      clusterOptions: [
        {
          width: 53,
          height: 53,
          url: clusterImg,
          textColor: 'white',
          textSize: 12,
        },
      ],
      markerImage: '/static/svg/uEA12-location.svg',
      markerCurrent: '/static/img/active-marker.png',
      announcementMapListResource,
      announcementOptionsResource,
    };
  },
  mounted() {
    console.log(window.language)
    this.logo = window.logo
    this.closeInfoWindow()
  },
  methods: {
    breakSettings() {
      this.infoWinOpen = false
      // this.mapStyle.draggable = true
      this.mapStyle.scrollwheel = true
      this.infoWindowActive = ''
      const elevators = Array.from(document.getElementsByClassName('elevator'));
      elevators.forEach(el => {
        el.classList.remove('active-elevator');
      });
    },
    toggleInfoWindow(marker, label) {
      this.toggleElevators = false
      this.infoWindowActive = label
      this.mapStyle.scrollwheel = false
      // this.mapStyle.draggable = false
      elevatorData.execute({ label }).then(({ data: { item } }) => {
        this.infoContent = item;
      })
      this.infoWinOpen = true
      this.zoom = 13;
      // this.center = this.infoWindowPos
      const currentElevator = document.getElementById(label);
      const elevators = Array.from(document.getElementsByClassName('elevator'));
      elevators.forEach(el => {
        el.classList.remove('active-elevator');
      });
      currentElevator.classList.add('active-elevator');
      console.log(document.getElementById('infoWindow').offsetHeight)
      this.infoWindowPos = {
        lat: parseFloat(marker.point_y),
        lng: parseFloat(marker.point_x),
      }
      this.center = {
        lat: parseFloat(marker.point_y + 50),
        lng: parseFloat(marker.point_x),
      }
    },
    closeInfoWindow() {
      // document.addEventListener('click', event => {
      //   const windowInfo = document.querySelector('.gm-style-iw-d')
      //   /* eslint-disable */
      //   let checkingMarker = false
      //   const target = event.target
      //   const placeOfElevators = document.getElementById('placeSideBar')
      //   console.log(event)
      //   if (target.getAttribute('src')) {
      //     checkingMarker = 'https://maps.gstatic.com/mapfiles/transparent.png' === target.getAttribute('src')
      //   }
      //   if (windowInfo) {
      //     if (windowInfo.contains(target) || checkingMarker || placeOfElevators.contains(target)) {} else {
      //       this.breakSettings()
      //       // document.removeEventListener('click');
      //     }
      //   }
      // })
    },
    setResults({ data: { items } }) {
      this.placesArray = items;
    },
  },
};
// build
</script>
